import LabelledDivRow from "components/LabelledDivRow";
import React from "react";

interface Props {
  sql: server.dto.SqlServerDiagnostic
}

const DatabaseRows = ({ sql }: Props) => {
  return <>
    <LabelledDivRow label="Database">
      <div>{sql.database}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Server">
      <div style={{ overflowWrap: "anywhere" }}>{sql.server}</div>
    </LabelledDivRow>
  </>;
};

export default DatabaseRows;